// Gujarati
export const gu = {
  'app.name':           'Kardolive',
  'app.tagline':        'ગ્રાહક પોર્ટલ',
  'app.signOut':        'સાઇન આઉટ',

  'login.email':        'ઇમેઇલ',
  'login.password':     'પાસવર્ડ',
  'login.signIn':       'સાઇન ઇન કરો',
  'login.signingIn':    'સાઇન ઇન થઈ રહ્યું છે…',
  'login.failed':       'સાઇન ઇન નિષ્ફળ',
  'login.newAccount':   'Kardolive પર નવા છો?',
  'login.createAccount':'મફત ખાતું બનાવો →',

  'nav.workspace':      'કાર્યસ્થળ',
  'nav.templates':      'ટેમ્પલેટ્સ',
  'nav.live':           'લાઇવ',
  'nav.rooms':          'રૂમ અને ચેટ',
  'nav.content':        'સામગ્રી',
  'nav.developer':      'ડેવલપર',
  'nav.account':        'ખાતું',

  'nav.overview':       'ઝાંખી',
  'nav.projects':       'પ્રોજેક્ટ્સ',
  'nav.chat':           'ચેટ કન્સોલ',
  'nav.sessions':       'સત્રો',
  'nav.streams':        'લાઇવ સ્ટ્રીમ',
  'nav.studio':         'સ્ટુડિયો',
  'nav.recordings':     'રેકોર્ડિંગ',
  'nav.apiKeys':        'API કી',
  'nav.webhooks':       'Webhooks',
  'nav.webhookTester':  'Webhook પરીક્ષક',
  'nav.networkTest':    'નેટવર્ક પરીક્ષણ',
  'nav.embed':          'એમ્બેડ વિજેટ્સ',
  'nav.sdk':            'SDK અને દસ્તાવેજો',
  'nav.docs':           'Developer docs',
  'nav.analytics':      'વિશ્લેષણ',
  'nav.settings':       'સેટિંગ્સ',

  'overview.welcome':       'પાછા આવ્યા તે આનંદ, {name}',
  'overview.plan':          '{tenant} · {plan} પ્લાન',
  'overview.newStream':     'નવો સ્ટ્રીમ',
  'overview.kpi.live':           'હાલ લાઇવ',
  'overview.kpi.live.broadcasting': 'સ્ટ્રીમ ચાલી રહ્યા છે',
  'overview.kpi.live.nothing':    'કંઈ લાઇવ નથી',
  'overview.kpi.total':           'કુલ સ્ટ્રીમ',
  'overview.kpi.total.sub':       'સર્વ સમય માટે',
  'overview.kpi.sessions':        'સત્રો · 30 દિવસ',
  'overview.kpi.sessions.sub':    'પ્રકાશન ઇવેન્ટ્સ',
  'overview.kpi.recordings':      'રેકોર્ડિંગ',
  'overview.kpi.recordings.sub':  'ચલાવવા માટે તૈયાર',
  'overview.recentStreams':       'તાજેતરના સ્ટ્રીમ',
  'overview.recentSessions':      'તાજેતરના સત્રો',
  'overview.viewAll':             'બધું જુઓ →',
  'overview.empty.title':         'હજુ સુધી કોઈ સ્ટ્રીમ નથી',
  'overview.empty.body':          'પ્રસારણ શરૂ કરવા તમારો પહેલો સ્ટ્રીમ બનાવો.',
  'overview.empty.action':        'સ્ટ્રીમ બનાવો',
  'overview.noSessions':          'હજુ કોઈ સત્ર નથી',

  'status.live':        'લાઇવ',
  'status.idle':        'નિષ્ક્રિય',
  'status.ended':       'સમાપ્ત',
  'status.archived':    'અભિલેખિત',

  'common.save':        'સાચવો',
  'common.cancel':      'રદ કરો',
  'common.delete':      'કાઢી નાખો',
  'common.edit':        'સંપાદિત કરો',
  'common.create':      'બનાવો',
  'common.confirm':     'ખાતરી કરો',
  'common.loading':     'લોડ થઈ રહ્યું છે…',
  'common.error':       'ભૂલ',
  'common.retry':       'ફરી પ્રયાસ કરો',

  // Dashboard navigation and account controls.
  "nav.skipContent": "પાનાની સામગ્રી પર જાઓ",
  "nav.streamTemplates": "સ્ટ્રીમ ટેમ્પલેટ",
  "nav.boards": "ઇન્ટરેક્ટિવ બોર્ડ",
  "nav.menu": "નેવિગેશન ખોલો",
  "nav.closeMenu": "નેવિગેશન બંધ કરો",
  "nav.scenarios": "ઉપયોગનાં દૃશ્યો",
  "nav.premieres": "પ્રીમિયર",
  "nav.clips": "ક્લિપ",
  "dashboard.account": "ખાતું",
  "dashboard.language": "ભાષા",
  "dashboard.appearance": "દેખાવ",
  "nav.allStreams": "બધી સ્ટ્રીમ",
  "nav.destinations": "પ્રસારણનાં ગંતવ્ય",
  "nav.ecommerce": "ઈ-કોમર્સ",
  "nav.products": "ઉત્પાદનો",
  "nav.services": "સેવાઓ",
  "nav.collections": "સંગ્રહો",
  "nav.orders": "ઓર્ડર",
  "nav.commerceSettings": "વેપાર સેટિંગ્સ",
  "nav.engagement": "સહભાગિતા",
  "theme.light": "હળવા મોડ પર જાઓ",
  "theme.dark": "ઘેરા મોડ પર જાઓ",
  "role.owner": "માલિક",
  "role.admin": "પ્રશાસક",
  "role.member": "સભ્ય",
  "role.viewer": "દર્શક",

  // Live Stream page content: never translate stored event names or API values.
  "streams.active": "સક્રિય",
  "streams.archived": "સંગ્રહિત",
  "streams.monitor": "સ્રોત મોનિટર",
  "streams.create": "લાઇવ સ્ટ્રીમ બનાવો",
  "streams.list": "યાદી",
  "streams.grid": "ગ્રીડ",
  "streams.view": "સ્ટ્રીમ દૃશ્ય",
  "streams.searchLabel": "ઇવેન્ટ શોધો",
  "streams.searchHint": "ઇવેન્ટના નામથી શોધો",
  "streams.solutionFilter": "પ્રકાર પ્રમાણે ઇવેન્ટ ફિલ્ટર કરો",
  "streams.statusFilter": "સ્થિતિ પ્રમાણે ઇવેન્ટ ફિલ્ટર કરો",
  "streams.dateFilter": "બનાવ્યાની તારીખ પ્રમાણે ફિલ્ટર કરો",
  "streams.allSolutions": "બધા પ્રકાર",
  "streams.custom": "હાલની અથવા કસ્ટમ ગોઠવણી",
  "streams.allStatuses": "બધી સ્થિતિઓ",
  "streams.anyTime": "બનાવ્યાની કોઈપણ તારીખ",
  "streams.last7": "છેલ્લા ૭ દિવસમાં બનાવેલ",
  "streams.last30": "છેલ્લા ૩૦ દિવસમાં બનાવેલ",
  "streams.count": "{total} માંથી {shown} ઇવેન્ટ બતાવવામાં આવે છે",
  "streams.noMatch": "ફિલ્ટર સાથે મેળ ખાતી કોઈ ઇવેન્ટ નથી.",
  "streams.clearFilters": "ફિલ્ટર દૂર કરો",
  "streams.refreshFailed": "સ્ટ્રીમની યાદી અપડેટ થઈ શકી નહીં",
  "streams.loadFailed": "સ્ટ્રીમ લોડ થઈ શકી નહીં",
  "streams.stale": "છેલ્લે લોડ કરેલી યાદી બતાવવામાં આવે છે. સ્થિતિ બદલાઈ હોઈ શકે છે.",
  "streams.connectionHint": "કનેક્શન તપાસો અને યાદી ફરી લોડ કરો.",
  "streams.retrying": "ફરી પ્રયાસ થઈ રહ્યો છે…",
  "streams.retry": "ફરી પ્રયાસ કરો",
  "streams.restoreFailed": "સ્ટ્રીમ પુનઃસ્થાપિત થઈ શકી નહીં",
  "streams.restoreHint": "ફરી પ્રયાસ પહેલાં કનેક્શન તપાસો અને નવીનતમ સ્થિતિ માટે યાદી અપડેટ કરો.",
  "streams.unused": "વણવપરાયેલી સ્ટ્રીમ: {count}",
  "streams.unusedHint": "કોઈ પ્રસારણ કે રીપ્લે નથી. યાદી ગોઠવવા સંગ્રહિત કરો; કશું કાઢી નાખવામાં આવશે નહીં.",
  "streams.reviewArchive": "સમીક્ષા કરીને સંગ્રહિત કરો",
  "streams.loading": "સ્ટ્રીમ લોડ થઈ રહી છે…",
  "streams.archiveEmpty": "સંગ્રહ ખાલી છે. સંગ્રહિત સ્ટ્રીમ અને રીપ્લે પુનઃસ્થાપિત ન કરો ત્યાં સુધી અહીં રહે છે.",
  "streams.restore": "પુનઃસ્થાપિત કરો",
  "streams.firstTitle": "તમારી પ્રથમ સ્ટ્રીમ બનાવો",
  "streams.firstBody": "વેચાણ, વર્ગ અથવા સેવા માટે ગોઠવણી પસંદ કરો અથવા ખાલી સ્ટ્રીમથી શરૂ કરો. બ્રાઉઝર, ફોન અથવા OBS થી પ્રસારણ કરો.",
  "streams.blank": "ખાલી સ્ટ્રીમ",
  "streams.broadcasts": "પ્રસારણ: {count}",
  "streams.replays": "રીપ્લે: {count}",
  "streams.sessions": "સત્રો: {count}",
  "streams.recordings": "રેકોર્ડિંગ: {count}",
  "streams.mode.BROADCAST": "પ્રસારણ",
  "streams.mode.LOW_LATENCY": "ઓછો વિલંબ",
  "streams.mode.REALTIME": "રીઅલ-ટાઇમ",
  "streams.key": "કી",
  "streams.archiveTitle": "વણવપરાયેલી સ્ટ્રીમ સંગ્રહિત કરો",
  "streams.archiveHint": "આ સ્ટ્રીમ ક્યારેય પ્રસારિત થઈ નથી. સંગ્રહિત ટૅબમાંથી ગમે ત્યારે પુનઃસ્થાપિત કરી શકો છો.",
  "streams.archiveFailed": "{count} સ્ટ્રીમ સંગ્રહિત થઈ શકી નહીં; તે લાઇવ થઈ હોઈ શકે છે. બાકીની સંગ્રહિત થઈ છે.",
  "streams.archiving": "સંગ્રહિત થઈ રહ્યું છે…",
  "streams.archiveCount": "{count} સંગ્રહિત કરો",
  "streamType.webinar": "વ્યવસાયિક વેબિનાર અને લોન્ચ",
  "streamType.classroom": "વર્ગો અને ટ્યુશન",
  "streamType.training": "કોર્પોરેટ તાલીમ",
  "streamType.conference": "પરિષદો અને પ્રદર્શનો",
  "streamType.shopping": "લાઇવ ખરીદી",
  "streamType.auction": "લાઇવ હરાજી",
  "streamType.consultation": "ખાનગી પરામર્શ",
  "streamType.creator": "ક્રિએટર અને સમુદાયનું લાઇવ",
  "streamType.audio": "ઓડિયો રૂમ અને પોડકાસ્ટ",
  "streamType.sports": "રમતગમત અને ઈ-સ્પોર્ટ્સ",
  "streamType.performance": "સંગીત કાર્યક્રમો અને પ્રસ્તુતિઓ",
  "streamType.community": "ઉપાસના અને ભંડોળ સંગ્રહ",
  "streamType.tour": "પ્રવાસ અને પ્રદર્શન",
  "streamType.fitness": "ફિટનેસ અને કાર્યશાળાઓ",
  "streamType.public-meeting": "સમાચાર અને જાહેર બેઠકો",
  "streamType.continuous": "સતત ચેનલો અને કેમેરા",
  "streams.close": "બંધ કરો",
};
